import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import {
  fetchAdminMaintenanceTypesSuccess,
  fetchAdminMaintenanceTypesFailure,
  addAdminMaintenanceTypesSuccess,
  addAdminMaintenanceTypesFailure,
  updateAdminMaintenanceTypeSuccess,
  updateAdminMaintenanceTypeFailure,
  deleteAdminMaintenanceTypeSuccess,
  deleteAdminMaintenanceTypeFailure,
  fetchAdminMaintenanceTypesByIDSuccess,
  fetchAdminMaintenanceTypesByIDFailure,
} from './action';
import {
  ADD_ADMIN_MAINTENANCE_TYPES,
  DELETE_ADMIN_MAINTENANCE_TYPES,
  FETCH_ADMIN_MAINTENANCE_TYPES,
  FETCH_ADMIN_MAINTENANCE_TYPES_ID,
  UPDATE_ADMIN_MAINTENANCE_TYPES,
} from './types';
import adminAxiosConfig from '../../../services/adminAxiosConfig';

/** Get all listed equipments */
function* fetchAdminMaintenanceTypes() {
  try {
    const res = yield adminAxiosConfig.get('/type-of-maintenances');
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminMaintenanceTypesSuccess({ response }));
    } else {
      yield put(fetchAdminMaintenanceTypesFailure());
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchAdminMaintenanceTypesFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the equipment list.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed equipments by equipment id */
function* fetchAdminMaintenanceTypesById({ id }) {
  try {
    const res = yield adminAxiosConfig.get(`/type-of-maintenances?equipmentId=${id}`);
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminMaintenanceTypesByIDSuccess({ response }));
    } else {
      yield put(fetchAdminMaintenanceTypesByIDFailure());
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchAdminMaintenanceTypesByIDFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the equipment list.',
      description: `${error.error}`,
    });
  }
}

/** Function to Add new Maintenance Type */
function* addAdminMaintenanceTypes({ payload }) {
  try {
    const res = yield adminAxiosConfig.post(`/type-of-maintenance`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(addAdminMaintenanceTypesSuccess({ response }));
      yield fetchAdminMaintenanceTypes();
      notification.success({
        message: 'Maintenance Type Added Successfully.',
      });
    } else {
      yield put(addAdminMaintenanceTypesFailure());
      notification.error({
        message: 'Something went wrong.Please try again!',
      });
    }
  } catch (error) {
    yield put(addAdminMaintenanceTypesFailure());
    notification.destroy();
    if (error.error === 'Validation error') {
      notification.warn({
        message: 'Enetered Maintenance Type already exist!',
      });
    } else {
      notification.error({
        message: 'A problem occured while adding the details.',
        description: `${error}`,
      });
    }
  }
}

/** Function to update Maintenance Types */
function* updateAdminMaintenanceTypes({ data, id }) {
  try {
    const res = yield adminAxiosConfig.put(`/type-of-maintenance/${id}`, data);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(updateAdminMaintenanceTypeSuccess({ response }));
      yield fetchAdminMaintenanceTypes();
      notification.success({
        message: 'Maintenance Type Updated Successfully.',
      });
    } else {
      yield put(updateAdminMaintenanceTypeFailure());
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield put(updateAdminMaintenanceTypeFailure());
    notification.destroy();
    notification.error({
      message: 'Maintenance Type Updation Failed.',
      description: `${error}`,
    });
  }
}

/** Function to Delete Maintenance Types */
function* deleteAdminMaintenanceTypes({ id }) {
  try {
    const res = yield adminAxiosConfig.delete(`/type-of-maintenance/${id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(deleteAdminMaintenanceTypeSuccess({ response }));
      yield fetchAdminMaintenanceTypes();
      notification.success({
        message: 'Maintenance Type Deleted Successfully.',
      });
    } else {
      yield put(deleteAdminMaintenanceTypeFailure());
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield put(deleteAdminMaintenanceTypeFailure());
    notification.destroy();
    notification.error({
      message: 'Maintenance Type Deletion Failed.',
      // description: `${error}`,
    });
  }
}

function* sowWatcher() {
  yield takeLatest(FETCH_ADMIN_MAINTENANCE_TYPES, fetchAdminMaintenanceTypes);
  yield takeLatest(FETCH_ADMIN_MAINTENANCE_TYPES_ID, fetchAdminMaintenanceTypesById);
  yield takeLatest(ADD_ADMIN_MAINTENANCE_TYPES, addAdminMaintenanceTypes);
  yield takeLatest(UPDATE_ADMIN_MAINTENANCE_TYPES, updateAdminMaintenanceTypes);
  yield takeLatest(DELETE_ADMIN_MAINTENANCE_TYPES, deleteAdminMaintenanceTypes);
}

function* adminMaintenanceSagas() {
  yield all([call(sowWatcher)]);
}

export default adminMaintenanceSagas;

export const FetchExcelEquipmentCheckAdminList = async () => {
  try {
    let url = `/equipment-type-checks/all`;
    const res = await adminAxiosConfig.get(url);
    const response = get(res, ['data'], {});
    console.log('response', response);
    if (res.status === 200) {
      return response;
    } else {
      notification.error({
        message: 'Something went wrong. Please try again.',
      });
      return null;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching spares master list.',
      description: `${error.error}`,
    });
    return null;
  }
};

export const downloadExcelFile = async () => {
  try {
    const res = await adminAxiosConfig.get('/equipment-check-masters/download');
    const { fileUrl, fileName } = res.data;

    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error downloading file:', error);
    notification.error({
      message: 'Failed to download file',
      description: error.message,
    });
    return false;
  }
};

export const fetchMaintenanceTypes = async () => {
  try {
    const response = await adminAxiosConfig.get('/type-of-maintenances');
    const maintenanceTypes = response?.data?.data?.rows;
    return maintenanceTypes;
  } catch (error) {
    console.error('Error fetching maintenance types:', error);
    notification.error({
      message: 'Failed to fetch maintenance types',
      description: error.message,
    });
    return [];
  }
};

export const downloadTemplateFile = async () => {
  try {
    const res = await adminAxiosConfig.get('/equipment-type-checks/template');
    const { fileUrl, fileName } = res.data;

    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName || 'equipment-checks-template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error downloading template:', error);
    notification.error({
      message: 'Failed to download template',
      description: error.message,
    });
    return false;
  }
};
